let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1hUWQ")).then(() => parcelRequire('ku91u'));